<template>
  <div class="feature-card flex flex-col items-center text-center group">
    <!-- Icon -->
    <div class="w-16 h-16 rounded-full bg-muted  flex items-center justify-center mb-3 transition-colors">
      <Icon :name="icon" class="w-8 h-8 text-primary dark:text-primary-400" />
    </div>
    
    <!-- Content -->
    <h3 class="text-base font-semibold mb-1 text-gray-900 dark:text-gray-100">{{ title }}</h3>
    <p class="text-sm text-gray-600 dark:text-gray-400">{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  icon: string
  title: string
  description: string
}>()
</script>

